import React from 'react';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';

function MedTextField(props: TextFieldProps) {
  return <TextField {...props} />;
}

export default MedTextField;
